// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__l1Ta0","link":"Breadcrumbs_link__ST78p","active-link":"Breadcrumbs_active-link__XsVEv","activeLink":"Breadcrumbs_activeLink__ldfs1"};